import React from "react";
import SelectorField from "../../common/Components/SearchBarField/SelectorField";
import { FormGroup, Label, Button } from "reactstrap";
import { Toggle } from "rsuite";
import StudioFilterBar from "../../common/Components/FilterBar/StudioFilterBar";

const CreateProductHeader = (props: any) => {
  return (
    <StudioFilterBar
      fields={[
        {
          id: "productFilter",
          label: "Product",
          kind: "select",
          placeholder: "Select product",
          value: props.selectedProduct || "",
          options: props.productOptions || [],
          disabled: !props.switchButton,
          onChange: (value: any) =>
            props.handleOnchangeProductFilter({
              name: "productFilter",
              value,
            }),
        },
      ]}
      onReset={props.handleResetData}
      hideAdd
      leading={
        <label className="hkp-filter-bar__variant">
          <span>Variant</span>
          <Toggle
            size="md"
            checked={props.switchButton}
            checkedChildren="Yes"
            unCheckedChildren="No"
            disabled={false}
            onChange={(checked: boolean) => {
              props.handleSwitchButton(checked);
            }}
          />
        </label>
      }
      wideToolbar={
        <div className="CreateProductHeader QuickFiltersHeader ps-3 pe-3">
          <div className="d-flex">
            <div className="InputColP">
              <Label check>Variant</Label>
              <FormGroup className="ms-2">
                <Toggle
                  size="lg"
                  checked={props.switchButton}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  onChange={(checked: boolean) => {
                    props.handleSwitchButton(checked);
                  }}
                />
              </FormGroup>
            </div>
            <div>
              <Button
                className="resetBtnMobile"
                onClick={() => {
                  props.handleResetData();
                }}
              >
                Reset
              </Button>
            </div>
          </div>

          <div className="InputColP">
            <SelectorField
              {...props}
              name="ProductFilter"
              placeholder="Select Product"
              options={props.productOptions}
              onChange={(e: any) =>
                props.handleOnchangeProductFilter({
                  name: "productFilter",
                  value: e,
                })
              }
              isDisabled={props.switchButton ? false : true}
              value={props.selectedProduct}
              onInputChange={(e: any) =>
                props.handleOnInputChangeFilters({
                  name: "productFilter",
                  value: e,
                })
              }
            />
          </div>
          <div className="InputColP d768640"></div>
          <div className="InputColP1 searchIcon">
            <Button
              className="ResetBtn"
              onClick={() => {
                props.handleResetData();
              }}
            >
              Reset
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default CreateProductHeader;
